export default {
    name: 'StarSky',
    dimensions: { width: 40, height: 40 },
    content: `
    <g clip-path="url(#clip0_31_102)">
    <path d="M27 8.00293C27 14.6329 21.63 20.0029 15 20.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M39 20.0029C32.37 20.0029 27 14.6329 27 8.00293" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M27 32.0029C27 25.3729 32.37 20.0029 39 20.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M15 20.0029C21.63 20.0029 27 25.3729 27 32.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M8 1.00293C8 4.87293 4.87 8.00293 1 8.00293" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M15 8.00293C11.13 8.00293 8 4.87293 8 1.00293" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M8 15.0029C8 11.1329 11.13 8.00293 15 8.00293" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M1 8.00293C4.87 8.00293 8 11.1329 8 15.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M12 25.0029C12 28.8729 8.87 32.0029 5 32.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M19 32.0029C15.13 32.0029 12 28.8729 12 25.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M12 39.0029C12 35.1329 15.13 32.0029 19 32.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M5 32.0029C8.87 32.0029 12 35.1329 12 39.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M27 8.00293V3.00293" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M27 37.0029V32.0029" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </g>
    <defs>
    <clipPath id="clip0_31_102">
    <rect width="40" height="40" fill="none" transform="translate(0.00292969 0.00292969)"/>
    </clipPath>
    </defs>
  `
};


